// Composer domain slice: busy/error state for the submit path. Field ownership and
// the fileUpload split: see .claude/context/store-slices.md.
export const composerSlice = (set) => ({
  isSubmitting: false,
  setIsSubmitting: (value) => set({ isSubmitting: value }),
  uploadError: null,
  setUploadError: (error) => set({ uploadError: error }),
  botLoading: false,
  setBotLoading: (value) => set({ botLoading: value }),
});
